import { render, staticRenderFns } from "./attendance_types.vue?vue&type=template&id=01e6a164&scoped=true"
import script from "./attendance_types.vue?vue&type=script&lang=js"
export * from "./attendance_types.vue?vue&type=script&lang=js"
import style0 from "./attendance_types.vue?vue&type=style&index=0&id=01e6a164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6a164",
  null
  
)

export default component.exports